import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import MuiLink from '@mui/material/Link';
import { RiPhoneLine, RiMailSendLine, RiEarthLine } from 'react-icons/ri';
import Flag from 'react-world-flags';
import { Typography700, BreadcrumbsV2, ImgBox } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
import StyledBox from 'views/rebranded-module/information-module/ContactUsViewV2/components/ContactUs/ContactUs.styles';

interface ContactUsProps {
  phoneNumbers?: Array<{
    name: string;
    value: string;
    identifier: string;
  }>;
}

const ContactUs: React.FC<ContactUsProps> = (props) => {
  const { phoneNumbers = [] } = props;
  const content = useContent('ContactUsPage');

  const breadcrumbsData = {
    links: [
      {
        text: 'EAGLERIDER',
        path: PATHS.home(),
      },
      {
        text: 'INFORMATION',
        path: PATHS.information(),
      },
      {
        text: 'CONTACT US',
        path: null,
      },
    ],
  };

  const usaPhone = phoneNumbers.find((item) =>
    item.identifier.includes('rental_in_usa')
  );
  const internationalPhone = phoneNumbers.find((item) =>
    item.identifier.includes('rental_out_usa')
  );
  return (
    <StyledBox>
      <Box className="CUContentContainer">
        <Container maxWidth="xxl" className="CUContainer">
          <Box className="CUWrapper">
            <Box className="CUBreadcrumbWrapper">
              <BreadcrumbsV2 data={breadcrumbsData} />
            </Box>
            <Box className="CUTitleWrapper">
              <Typography700 variant="h2" className="CUTitle">
                {content.title}
              </Typography700>
              <Typography variant="body2" className="CUSubtitle">
                {content.subheading}
              </Typography>
            </Box>

            <Box className="CUContactInfoWrapper">
              <Box className="CUCallUsSection">
                <Box className="CUSectionHeader">
                  <RiPhoneLine className="CUIcon" />
                  <Typography700 variant="h6" className="CUSectionTitle">
                    {content.callUs}
                  </Typography700>
                </Box>
                <Box className="CUPhoneNumbers">
                  {usaPhone && (
                    <MuiLink href={`tel:${usaPhone.value}`} className="CUPhoneItem">
                      <Flag code="US" className="CUFlagIcon" />
                      <Typography variant="body1" className="CUPhoneLabel">
                        {content.usaPhoneLabel}
                      </Typography>
                      <Typography variant="body1" className="CUPhoneValue">
                        {usaPhone.value}
                      </Typography>
                    </MuiLink>
                  )}
                  {internationalPhone && (
                    <MuiLink href={`tel:${internationalPhone.value}`} className="CUPhoneItem">
                      <RiEarthLine className="CUPhoneIcon" />
                      <Typography variant="body1" className="CUPhoneLabel">
                        {content.internationalPhoneLabel}
                      </Typography>
                      <Typography variant="body1" className="CUPhoneValue">
                        {internationalPhone.value}
                      </Typography>
                    </MuiLink>
                  )}

                </Box>
              </Box>

              <Box className="CUMailUsSection">
                <Box className="CUSectionHeader">
                  <RiMailSendLine className="CUIcon" />
                  <Typography700 variant="h6" className="CUSectionTitle">
                    {content.mailUs}
                  </Typography700>
                </Box>
                <Box className="CUAddress">
                  <Typography variant="body1" className="CUAddressLine">
                    {content.corporateHeadquarters}
                  </Typography>
                  <Typography variant="body1" className="CUAddressLine">
                    {content.addressLine1}
                  </Typography>
                  <Typography variant="body1" className="CUAddressLine">
                    {content.addressLine2}
                  </Typography>
                  <Typography variant="body1" className="CUAddressLine">
                    {content.addressCountry}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </StyledBox>
  );
};

export { ContactUs };

